import React from 'react';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

import card1iconSrc from '@/assets/aixuehome2-card1-icon.png';
import card2iconSrc from '@/assets/aixuehome2-card2-icon.png';
import card3iconSrc from '@/assets/aixuehome2-card3-icon.png';
import card4iconSrc from '@/assets/aixuehome2-card4-icon.png';

// 第二屏：AI一对一教育新范式
export default function Screen2() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen2-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-home-scroll',
    enableResizeDetection: true
  });
  return (
    <section className={styles['screen2-cover']} ref={rootRef}>
      <div className={styles['screen2-wrap']}>
        {/* 标题 */}
        <div className={styles['screen2-title-container']}>
          <h2 className={styles['screen2-title']}>AI一对一教育新范式</h2>
        </div>

        <div className={styles['screen2-cards']}>
          <div className={`${styles['screen2-cards-row']} ${styles['screen2-cards-row1']}`}>
            <div className={`${styles['screen2-card']} ${styles['screen2-card1']}`}>
              <img className={styles['screen2-card-icon']} src={card1iconSrc} alt="真人级" />
              <div className={styles['screen2-card-content']}>
                <h3 className={styles['screen2-card-title']}>真人级</h3>
                <p className={styles['screen2-card-desc']}>
                  毫秒响应、情感理解、多模态融合的类人交互体验
                </p>
              </div>
            </div>

            <div className={`${styles['screen2-card']} ${styles['screen2-card2']}`}>
              <img
                className={styles['screen2-card-icon']}
                src={card2iconSrc}
                alt="大师级"
              />
              <div className={styles['screen2-card-content']}>
                <h3 className={styles['screen2-card-title']}>大师级</h3>
                <p className={styles['screen2-card-desc']}>
                  沉淀顶尖教育专家方法论，确保专业深度与权威性
                </p>
              </div>
            </div>
          </div>

          <div className={styles['screen2-cards-row']}>
            <div className={`${styles['screen2-card']} ${styles['screen2-card3']}`}>
              <img
                className={styles['screen2-card-icon']}
                src={card3iconSrc}
                alt="专属级"
              />
              <div className={styles['screen2-card-content']}>
                <h3 className={styles['screen2-card-title']}>专属级</h3>
                <p className={styles['screen2-card-desc']}>
                  通过持续互动的长短期记忆与适配，实现终身成长的个性化陪伴
                </p>
              </div>
            </div>

            <div className={`${styles['screen2-card']} ${styles['screen2-card4']}`}>
              <img
                className={styles['screen2-card-icon']}
                src={card4iconSrc}
                alt="更普惠"
              />
              <div className={styles['screen2-card-content']}>
                <h3 className={styles['screen2-card-title']}>更普惠</h3>
                <p className={styles['screen2-card-desc']}>更强的技术、更多的学员、更低的价格</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
